import React from "react";
// import { extractDate } from "../../Components/Functions/date.fun";
// import CustomViewButton from "../../CustomComponent/custom_view_button";

const tableHead = [
  "Month/Employee",
  "Pay.Sal/Sal.Per.mon",
  "pay days",
  "Inc.",
  "PF/PT",
  "TDS/ESIC",
  "Sal.Adj",
  "paid/leaves",
  "penulty leaves/amt",
];

const AllsalaryTable = ({ data, currentPage, itemsPerPage }) => {
  let newData = data?.map((el, index) => {
    let paybleSalary = 0;
    if (el?.paybleSalary) {
      paybleSalary += +el?.paybleSalary;
    }
    if (el?.salaryAdjust?.ammount && el?.salaryAdjust?.type) {
      el?.salaryAdjust?.type === "addition"
        ? (paybleSalary += +el?.salaryAdjust?.ammount)
        : (paybleSalary -= +el?.salaryAdjust?.ammount);
    }
    return { ...el, totalCalSalary: paybleSalary };
  });

  //   const goToView = (id) => {
  //     navigate(`/si-updates/view/${id}`);
  //   };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {newData?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                {/* <td>{Index}</td> */}
                <td>
                  {item?.month}-{item?.year}
                  <br />
                  {item?.employeeData?.firstName} {item?.employeeData?.lastName}
                </td>

                <td>
                  {item?.salaryData?.salaryPerMonth ??
                    item?.employeeData?.salaryPerMonth ??
                    "N/A"}{" "}
                  / {item?.totalCalSalary?.toFixed(2) || "N/A"}
                </td>
                <td>
                  {`${item?.totalPayableDays} / ${item?.monthTotalDays}` ||
                    "0/0"}{" "}
                </td>
                <td>
                  {"+  ₹"}
                  {item?.incentiveEmployee?.toFixed(2) || 0}
                </td>
                <td>
                  {item?.salaryData?.pfDeductionPerMonth ?? 0} /{" "}
                  {item?.salaryData?.ptDeductionPerMonth ??
                    item?.employeeData?.pfptDeduction ??
                    0}
                </td>
                <td>
                  {item?.salaryData?.tdsPerYear ?? 0} /{" "}
                  {(
                    Number(item?.salaryData?.esicEmployeePerMonth ?? 0) +
                    Number(item?.salaryData?.esicEmployerPerMonth ?? 0)
                  ).toFixed(2)}
                </td>
                <td>
                  {item?.salaryAdjust?.ammount ? (
                    <>
                      {item?.salaryAdjust?.type &&
                      item?.salaryAdjust?.type === "deduction"
                        ? "-"
                        : "+"}
                      {` ₹${item?.salaryAdjust?.ammount}`}
                    </>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>
                  {item?.applicablePaidLeaves} / {item?.totalLeavsDays}
                </td>
                <td>
                  {item?.penultyCount ? (
                    <>
                      {item?.penultyCount} /- ₹
                      {(+item?.penultyCount * +item?.perDaySalary).toFixed(2)}
                    </>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllsalaryTable;
